export default {
    listagem: {
        titulo_pagina: 'Lista de Transmissões',
        table: {
            transmissao: "Transmissão",
            resposta: "Resposta",
            mensagem: "Mensagem",
            criadoem: "Criado em",
            empty: "Nenhuma Transmissão encontrada",
            visualizar: "Visualizar"
        }
    },
    show: {
        title: 'Visualizar Transmissão'
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova transmissão',
            editar: 'Editar Transmissão'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Estado'
            },
            botao_salvar : 'Transmitir Resultado'
        },
        create: {
            success: "Resultado transmitido com Sucesso!",
            error: "Error ao transmitir resultado!"
        },
        update: {
            success: "Resultado editado com Sucesso!",
            error: "Error ao editar resultado!"
        }
    },
    transmissao: {
        titulo_pagina: 'Reportar exame ao RNDS',
        importacao_massa: 'Importação em Massa',
        funcionalidade_contrucao: 'Funcionalidade em Construção...',
        escolha_arquivo_importacao: 'Escolha um arquivo para importar',
        arraste_solte_arquivo: 'Ou araste um arquivo e solte aqui',
        selecionar: 'Selecionar',
        separador: 'Separador',
        arquivo_importacao_valores: {
            tab: 'Tab',
            pipe: 'Pipe',
            espaco: 'Espaço',
            virgula: 'Vírgula',
            ponto: 'Ponto'
        },
        quantidade_coluna: 'Quantidade de Colunas',
        importar: 'Importar',
        campos: {
            cpf_label: 'CPF',
            cpf_descricao: 'CPF do Paciente',
            cns_label: 'CNS',
            cns_descricao: 'CNS do Responsável Técnico',
            exame_label: 'Exame',
            resultado_label: 'Resultado',
            resultado_valores: {
                detectavel: 'Detectável',
                nao_detectavel: 'Não Detectável',
                inconclusivo: 'Inconclusivo',
            },
            amostra_biologica_label: 'Amostra Biológica',
            data_label: 'Data',
            data_descricao: 'Data do Processamento',
            uf_laboratorio_label: 'UF do Laboratório'
        },
        reporte_enviado: 'Reporte Enviado! Confira a lista para o Status',
        erro_reportar_exame: 'Erro ao Reportar exame'
    }
}
